import { getApiHost } from "components/helpers";


export const oauthBaseRoute = `${getApiHost()}/saml/login`;
